export const globalConfig = {
  enableOptionSetTranslation: true,
  googleTranslateOnlyEmptyTranslations: true,
};
